﻿import Vue from "vue";
import Component from "vue-class-component";
import common from "../../../common";
import HotEditableFormManager_ from "./HotEditableFormManager";
import utilities_ from "../../utilities";
import HotEditableHelpers_ from "./HotEditableHelpers";

const utilities = require("../../utilities") as typeof utilities_;
// const HotEditableFormManager = require("./HotEditableFormManager") as HotEditableFormManager_;
// const HotEditableHelpers = require("./HotEditableHelpers") as HotEditableHelpers_;

declare function __getHotEditableDocumentUploadComponentTemplate(): string;

interface IElementValue {
    id?: string;
    fileName?: string;
    fileUrl?: string;
    /** utilise dans le typescript seulement pour differencier 2 elementValue */
    timestamp?: number;
}

@Component({
    props: {
        initId: String,
        initName: String,
        initClass: String,
        initCssOptions: String,
        initValue: Object,
        initEmptyValue: Object,
        initDefaultValue: String,
        initTabIndex: Number,
        initDisplayName: String,
        initRequired: String,
        initDisabled: String,
        initPlaceholder: String,
        initEditModeOn: Boolean,
        initCanChangeEditMode: Boolean,
        initClearable: Boolean,
        initCanDownloadFile: Boolean,
        initButtonTextAdd: String,
        initButtonTextChange: String,
        initDownloadFileText: String,
        initAccept: String
    }
})
class HotEditableDocumentUploadComponent extends Vue implements common.IHotEditableFieldComponent {

    initId?: string;
    initName?: string;
    initClass?: string;
    initCssOptions?: string;
    initValue?: IElementValue;
    initEmptyValue?: IElementValue;
    initDefaultValue?: string;
    initTabIndex?: number;
    initDisplayName?: string;
    initPlaceholder?: string;
    initRequired?: string;
    initDisabled?: string;
    initEditModeOn?: boolean;
    initCanChangeEditMode?: boolean;
    initClearable?: boolean;
    initAccept?: string;
    initCanDownloadFile?: boolean;
    initButtonTextAdd?: string;
    initButtonTextChange?: string;
    initDownloadFileText?: string;

    rootId?: string;
    editModeOn?: boolean;
    canChangeEditMode?: boolean;
    elementValue?: IElementValue | null;
    emptyValue?: IElementValue;
    defaultValue?: string;
    tabIndex?: number;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    elementName?: string;
    idElement?: string;
    displayName?: string;
    cssClass?: string;
    cssOptions?: string;
    clearable?: boolean;
    clearableCurrent?: boolean;
    accept?: string;
    buttonTextAdd?: string;
    buttonTextChange?: string;
    downloadFileText?: string;
    canDownloadFile?: boolean;
    hasError?: boolean;
    isInitialized?: boolean;
    fieldType = common.HotEditableFieldTypes.documentUpload;

    _isApiRunning = false;
    _previousValue? = {} as IElementValue | null;//NOTE?:  Doit etre NULL (defined) car il est definie dans le "created" (vue)
    _formManager?: HotEditableFormManager_ | null;//NOTE?:  Doit undefined initialement car il est definie dans le "beforeCreate" (vue)

    static tagName = "hoteditabledocumentupload";
    // static prepareMarkup(element: HTMLElement) {
    //     if (!element)
    //         throw "[" + this.tagName + "::prepareMarkup] L'element est NULL";
    //     element.removeAttribute("hot-editable");
    //     element.setAttribute("hot-editable-cloak", "");
    //     const newOuterHtml = element.outerHTML.replace('<input ', '<' + this.tagName + ' ')
    //         .replace(' type="file"', ' ')
    //         .replace(' id=', ' init-id=')
    //         .replace(' name=', ' init-name=')
    //         .replace(' class=', ' init-class=')
    //         .replace(' css-options=', ' init-css-options=')
    //         .replace(' value=', ' v-bind:init-value=')
    //         .replace(' empty-value=', ' v-bind:init-empty-value=')
    //         .replace(' default-value=', ' init-default-value=')
    //         .replace(' required=', ' init-required=')
    //         .replace(' disabled=', ' init-disabled=')
    //         .replace(' placeholder=', ' init-placeholder=')
    //         .replace(' display-name=', ' init-display-name=')
    //         .replace(' clearable=', ' v-bind:init-clearable=')
    //         .replace(' tabindex=', ' v-bind:init-tab-index=')
    //         .replace(' upload-api-url=', ' init-upload-api-url=')
    //         .replace(' delete-api-url=', ' init-delete-api-url=')
    //         .replace(' button-text-add=', ' init-button-text-add=')
    //         .replace(' button-text-change=', ' init-button-text-change=')
    //         .replace(' download-file-text=', ' init-download-file-text=')
    //         .replace(' accept=', ' init-accept=')
    //         .replace(' can-download-file=', ' v-bind:init-can-download-file=')
    //         .replace(' edit-mode-on=', ' v-bind:init-edit-mode-on=')
    //         .replace(' can-change-edit-mode=', ' v-bind:init-can-change-edit-mode=');
    //     element.outerHTML = newOuterHtml;
    // }

    data() {
        const isClearable = this.initClearable === true;
        const defaultValues = {
            emptyValue: {
                fileName: "Aucun document"
            } as IElementValue,
            buttonTextAdd: 'Ajouter',
            buttonTextChange: 'Modifier',
            placeholder: 'Sélectionner un document',
            downloadFileText: 'Télécharger le fichier',
        };

        const guid = utilities.createGuid('N');
        const id = this.initId || "Field_" + guid;
        const value = this.initValue || {} as IElementValue;
        const o = {
            rootId: "HotEditableField_" + guid,
            idElement: id,
            elementName: this.initName || id,
            editModeOn: this.initEditModeOn === true,
            canChangeEditMode: this.initCanChangeEditMode === true,
            elementValue: value,
            emptyValue: this.initEmptyValue || defaultValues.emptyValue,
            defaultValue: this.initDefaultValue || '',
            tabIndex: this.initTabIndex,
            displayName: this.initDisplayName || null,
            required: this.initRequired === 'required',
            disabled: this.initDisabled === 'disabled',
            placeholder: this.initPlaceholder || defaultValues.placeholder,
            cssClass: this.initClass || '',
            cssOptions: this.initCssOptions || '|none|',
            clearable: isClearable,
            clearableCurrent: isClearable,
            canDownloadFile: this.initCanDownloadFile === true,
            accept: this.initAccept || '',
            buttonTextAdd: this.initButtonTextAdd || defaultValues.buttonTextAdd,
            buttonTextChange: this.initButtonTextChange || defaultValues.buttonTextChange,
            downloadFileText: this.initDownloadFileText || defaultValues.downloadFileText,
            hasError: false,
            isInitialized: false,
        };
        return o;
    }

    updatePreviousValue(value?: IElementValue) {
        this._previousValue = value || this.copyElementValue();
        return this;
    }

    changeMode(canChangeEditMode?: boolean, editModeOn?: boolean) {
        this.updatePreviousValue();
        this.canChangeEditMode = canChangeEditMode;
        this.editModeOn = editModeOn;
    }

    isClearable() {
        return this.clearable && this.clearableCurrent;
    }

    private updateClearableCurrent(value?: boolean) {
        value = value === true || value === false ? value : this.hasSettedFile();
        this.clearableCurrent = value;
    }

    /** Format: id|fileName|previewUrl|fileUrl */
    setFromTextualValue(textualValue?: string) {
        textualValue = textualValue || '';

        if (!textualValue) {
            this.elementValue = {} as IElementValue;
            this.updateClearableCurrent();
            return this;
        }

        const parts = textualValue.split('|');
        if (parts.length < 2)
            throw "[HotEditableDocumentUpload::setFromTextualValue] La valeur textuelle est invalide (id|fileName|fileUrl).";

        const id = parts[0] || '';
        const fileName = parts[1] || '';
        const fileUrl = parts[2] || '';
        const timespan = !id ? null : this.getCurrentTimespan();

        this.updatePreviousValue();

        this.elementValue = {
            id: id,
            fileName: fileName,
            timestamp: timespan,
            fileUrl: this.appendTimespan(fileUrl, timespan)
        } as IElementValue;

        var hasFile = this.hasSettedFile();

        this.updateClearableCurrent(hasFile);

        if (!hasFile)
            this.resetInputFile();

        return this;
    }

    /** Format: id|fileName|previewUrl|fileUrl */
    getTextualValue() {
        const v = this.elementValue || {} as IElementValue;

        return '{a}|{b}|{c}'
            .replace("{a}", v.id || '')
            .replace("{b}", v.fileName || '')
            .replace("{c}", v.fileUrl || '');
    }

    created() {
    }

    mounted() {
        HotEditableHelpers_.validateFieldSettings(this);

        (this.$el as Element).removeAttribute("hot-editable-cloak");

        this.updatePreviousValue();
        this.updateClearableCurrent();

        // // permet de faire fonctionner le blur
        // document.addEventListener("mousedown", e => {
        //     if (!this.canChangeEditMode || !this.editModeOn)
        //         return;
        //     const root = this.$refs["root"] as Element;

        //     if (utilities.isOutsideElement(e.target as Element, root))
        //         this.onBlur(e);
        // });
    }

    onButtonClick(event?: Event) {
        this.preventDefault(event, true);
        this.selectFile();
    }

    onSummaryClick(event: Event) {
        this.preventDefault(event);

        if (this.isReadonly())
            return;

        this.selectFile();
    }
    onFileSelected(event: Event) {

        if (this.isReadonly())
            return;

        const fileValue = this.getInputInstance().value;
        const timespan = fileValue ? this.getCurrentTimespan() : null;
        const fileName = timespan ? fileValue.split('\\fakepath\\')[1] : '';

        this.elementValue = {
            id: utilities.emptyGuid("N"),
            fileName: fileName,
            timestamp: timespan
        } as IElementValue;

        // Donne le temps a hidden field (ID) d'etre modifie
        this.$nextTick(() => {
            this.changed();
        });
    }
    private preventDefault(e?: Event, bypassStopPropagation?: boolean) {
        if (!e)
            return;

        e.preventDefault();

        if (bypassStopPropagation !== true)
            e.stopPropagation();
    }
    selectFile() {
        const instance = this.getInputInstance();
        instance.value = null as any;
        instance.click();
    }
    isDownloadable(value: IElementValue) {
        return this.canDownloadFile && this.getFileUrl(value);
    }
    isReadonly() {
        return !this.editModeOn && !this.canChangeEditMode;
    }
    getFileUrl(value: IElementValue) {
        return value && value.fileUrl ? value.fileUrl : '';
    }
    getInputInstance() {
        return this.$refs["inputInst"] as HTMLInputElement;
    }

    _defaultFileName = 'Document sans nom';
    getFileName(value: IElementValue, showPlaceholder?: boolean) {
        if (this.hasSettedFile(value))
            return value.fileName || this._defaultFileName;
        return (showPlaceholder ? this.placeholder : (this.emptyValue || {}).fileName) || '';
    }
    getHiddenFieldValue(value: IElementValue) {
        return value ? value.id : '';
    }
    getButtonText(value: IElementValue) {
        return value && value.id ? this.buttonTextChange : this.buttonTextAdd;
    }
    copyElementValue() {
        if (!this.elementValue)
            return this.elementValue;
        return {
            id: this.elementValue.id,
            fileName: this.elementValue.fileName,
            timestamp: this.elementValue.timestamp
        } as IElementValue;
    }
    isSameElementValue(a: IElementValue, b?: IElementValue | null) {
        if (!a && !b)
            return true;
        if (!a || !b)
            return false;
        return a.timestamp === b.timestamp; //&& a.id === b.id && a.fileName === b.fileName 
    }
    beforeCreate() {
        this._formManager = ((this.$parent as any).formManager as HotEditableFormManager_).registerField(this);
        this.$options.template = __getHotEditableDocumentUploadComponentTemplate();
    }

    // editClick(event?: Event | null, forcedMode?: boolean) {
    //     return;

    //     // if (!this.canChangeEditMode)
    //     //     return;

    //     // this.updatePreviousValue();

    //     // if (forcedMode === true || forcedMode === false) {
    //     //     this.editModeOn = forcedMode;
    //     // } else {
    //     //     //toggle
    //     //     this.editModeOn = !this.editModeOn;
    //     // }

    //     // if (this.editModeOn)
    //     //     this.updateClearable();

    //     // this._formManager.editModeChanged(this);

    //     //this.focus();
    // }

    onEnterClick(event?: KeyboardEvent) {
        if (this.canChangeEditMode)
            this.preventDefault(event);

        this.changed();
    }

    onEscapeClick(event?: KeyboardEvent) {
        if (this.canChangeEditMode)
            this.preventDefault(event);

        this.cancel();
    }

    onCancel(event: Event) {
        this.preventDefault(event);
        this.cancel();
    }

    onClear(event: Event) {
        this.preventDefault(event);
        this.clear();
    }

    clear() {
        this.elementValue = {} as IElementValue;
        this.resetInputFile();
        this.$nextTick(() => {
            this.changed();
        });
    }

    resetInputFile() {
        this.getInputInstance().value = '';
    }

    changed() {
        this.elementValue = this.elementValue || {} as IElementValue;
        this.updateClearableCurrent();

        if (this.canChangeEditMode) {
            this.editModeOn = false;
            this._formManager?.editModeChanged(this);
            if (this.isSameElementValue(this.elementValue, this._previousValue))
                return;
        }

        this._formManager?.fieldChanged(this);
    }

    cancel() {
        if (!this.canChangeEditMode)
            return;

        this.elementValue = this._previousValue;

        this.editModeOn = false;

        //NOTE: Le "blur()" va lancer le "changed()"
        //this.$root.$emit('hotEditableTextbox-editModeChanged', this);
    }

    // blur() {
    //     //this.changed();
    //     //setTimeout(() => { this.changed(true); }, 250);
    // }

    // focus() {
    //     // this.$nextTick(() => {
    //     //     this.getInputInstance().focus();
    //     // });
    // }

    hasSettedFile(value?: IElementValue) {
        return value ? !!value.timestamp : !!(this.elementValue || {}).timestamp;
    }

    /** retournera EMPTY si l'url est vide */
    private appendTimespan(url: string, timespan?: number | null) {
        const updatedUrl = url
            ? url + (url.indexOf('?') < 0 ? '?' : '&') + 't=' + (timespan || this.getCurrentTimespan())
            : '';
        return updatedUrl;
    }

    private getCurrentTimespan() { return Date.now(); }

    // onTabClick(event?: KeyboardEvent) {
    //     //NOTE: Not used in the textbox because the tab has a builtin behavior to blur and blur() method will call the changed() method.
    //     if (event.shiftKey) {
    //         this.onShiftTabClick(event);
    //         return;
    //     }

    //     this.focusNextComponent();

    //     if (event && this.canChangeEditMode) {
    //         event.preventDefault();
    //         event.stopPropagation();
    //     }
    // }

    // onShiftTabClick(event?: KeyboardEvent) {
    //     //NOTE: Not used in the textbox because the tab has a builtin behavior to blur and blur() method will call the changed() method.
    //     this.focusNextComponent(true);

    //     if (event && this.canChangeEditMode) {
    //         event.preventDefault();
    //         event.stopPropagation();
    //     }
    // }

    // private focusNextComponent(getPrevious?: boolean) {
    //     getPrevious = getPrevious === true;

    //     if (!this.canChangeEditMode)
    //         return false;

    //     this.changed();
    //     this.editClick(null, false);

    //     if (getPrevious)
    //         this._formManager.focusPreviousComponentFromField(this)
    //     else
    //         this._formManager.focusNextComponentFromField(this);
    // }

}

export = HotEditableDocumentUploadComponent;